import { __rest } from "tslib";
import { useMemo } from 'react';
const mapRoleToSelectedAttribute = (role) => ['gridcell', 'option', 'row', 'tab'].includes(role)
    ? 'aria-selected'
    : 'aria-current';
const getItemAriaAttributes = (props) => {
    const { role = 'listitem', isSelected } = props;
    return {
        role,
        [mapRoleToSelectedAttribute(role)]: isSelected,
    };
};
/**
 * For props passed to Item component returns memoized (for context provider)
 * props with proper defaults and calculations
 */
export const useItemProps = (_a) => {
    var { size = 'sm', isHoverable = true, borderRadius = 'sm', isSelected = false, showCheckIconWhenSelected = false, selectionVariant = 'solid', variant = 'primary', isFocused = false, isStriped = false } = _a, rest = __rest(_a, ["size", "isHoverable", "borderRadius", "isSelected", "showCheckIconWhenSelected", "selectionVariant", "variant", "isFocused", "isStriped"]);
    return ({
        props: useMemo(() => ({
            size,
            isHoverable,
            borderRadius,
            isSelected,
            showCheckIconWhenSelected,
            selectionVariant,
            variant,
            isFocused,
            isStriped,
        }), [
            borderRadius,
            isFocused,
            isHoverable,
            isSelected,
            isStriped,
            selectionVariant,
            showCheckIconWhenSelected,
            size,
            variant,
        ]),
        aria: getItemAriaAttributes(Object.assign({ isSelected }, rest)),
        rest,
    });
};
//# sourceMappingURL=useItemProps.js.map